import { Checkbox } from "components/Atoms/inputs/Checkbox";
import CultureLabel from "components/Culture/CultureLabel";
import { VerticalKeyboardNavigationGroup } from "keyboardNavigation/KeyboardNavigationPresets";
import React from "react";

interface Props {
  value: server.dto.Culture[]
  onChange: (tags: server.dto.Culture[]) => void
}

const CulturesSelect = (props: Props) => {
  const selected = new Set(props.value.map(v => v.value));

  const onChange = (culture: server.dto.Culture, checked: boolean) => {
    const newCultures = checked
      ? [...props.value, culture]
      : props.value.filter(c => c.value !== culture.value);
    props.onChange(newCultures);
  }

  return <div className="multiple-columns">
    {serverReference.interfaceCultures.map(opt => (
      <div className="margin-bottom-mini" key={opt.value}>
        <Checkbox
          keyboardNavigationOptions={VerticalKeyboardNavigationGroup("cultureSelect")}
          checked={selected.has(opt.value)}
          label={<CultureLabel culture={opt} />}
          onChange={(_, checked) => { onChange(opt, checked); }}
        />
      </div>
    ))}
  </div>;
};

export default CulturesSelect;